import { useEffect, useMemo, useState } from "react";
import { HeaderTitle } from "../../../components/header/Header";
import Container from "../../../components/layout/Container";
import { HeaderReport } from "../components/header.main";
import { first_reload } from "../../tax_plan/functions/firstLoad";
import { useNavigate } from "react-router-dom";
import { CardReport } from "../components/cardMenu";
import numeral from "numeral";
import { useBalanceStore } from "../../../_store/balanceStore";
import { MTButton } from "../../../components/button/MTButton";
import {
  STYLE_FLEX_STATUS,
  STYLE_REPORT_CONTAIN,
} from "../../../utils/useStyle";
import ViewMyPortResult from "../../invest/component/VIMyPortResult.Main";
import { cn, mapStatus } from "../../../utils/useFunctions";
import { useRetireStore } from "../../../_store/retireStore";
import { useTaxStore } from "../../../_store/taxplanStore";
import HalfChartMain from "../../../components/chart/HalfChartMain";
import {
  ICON_BAHT,
  ICON_CHECK,
  ICON_CLOSE,
  ICON_GRAPH,
  ICON_SAVING,
  ICON_STAR,
  ICON_WARNING,
} from "../../../utils/useIcons";
import { calculateTax, checkSum } from "../../tax_plan/functions";
import {
  dataAge,
  dataAgeAF,
  loopInvestmentAssets,
  loopInvestmentAssetsAF,
} from "../../retirement_plan/functions/functionRetriementPlan";
import { calPMT, calPMTFVA } from "../../education/functions/function";
import _ from "lodash";
import LineChartMain from "../../../components/chart/LineChartMain";
import {
  InvestmentReturnCalAfter,
  InvestmentReturnCalAfterNormal,
} from "../../../functions/retirement/retirementFunctionAfter";
import { useUserStore } from "../../../_store/userStore";
import { useStrategyStore } from "../../../_store/strategyRetireStore";
import { calculateCurrentTaxPlanDeductionTotal } from "../../../functions/taxFucntion/current-tax-calculation";
import {
  TabThreeExpenseCalculation,
  TabThreeSumIncomeCalculation,
} from "../../../functions/taxFucntion/premium/tab3function";
import {
  sum408property,
  sum408RecieveMoney,
} from "../../../functions/taxFucntion/premium/tab4function";
import {
  SumDebtPersonalValue,
  SumOtherDebtAmount,
} from "../../../functions/Balance/sumValueBalance";
import { calculateBasicLiquidityRatio } from "../../../functions/Balance/basic-liquidity-ratio";
import { calculateDebtToTotalAssets } from "../../../functions/Balance/debt-to-total-assets";
import { calculateExpenseSummary } from "../../../functions/Balance/expense-summary";
import {
  sumCapitalInvest,
  sumDebtInvest,
  sumPersonalAsset,
} from "../../../functions/Balance/sumProperty";
import {
  InvestmentReturnCal,
  InvestmentReturnNormalCal,
} from "../../../functions/retirement/retirementFunction";
import { useIsMobile } from "../../../utils/useIsMobile";
import { ImageMain } from "../../../components/img/Img.Main";
import { useEducationStore } from "../../../_store/educationStore";

// แสดงยอดรายจ่ายจาก owner กลาง เพื่อให้ยอดรวมและคำอธิบายการจัดสรรกระแสเงินสดใช้ผลคำนวณชุดเดียวกัน
const OverAllSection = ({ balanceData }) => {
  const [ReturnInsurance, setReturnInsurance] = useState([]);
  const expenseSummary = calculateExpenseSummary(balanceData);

  useEffect(() => {
    if (balanceData) {
      let tempInsuranceReturn = balanceData?.expenses_fixed_list
        ?.filter(
          (item) => item.options_expenses_fixed === "expenses_insuarant_life"
        )
        ?.map((item) => item.expenses_insuarant_lifes)
        ?.flat();

      let tempBalanceData = {};
      //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//

      if (
        balanceData?.property_invest_list
          ?.map((item) => item.options_property_invest_title)
          .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
        tempInsuranceReturn?.length === 0
      ) {
        // ถ้ามีหัวข้อนี้อยู่แล้ว
        let tempNameList = balanceData?.property_invest_list
          .find(
            (item) =>
              item?.options_property_invest_title ===
              "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
          )
          ?.invest_other_lists?.filter((item) => item !== null)
          ?.map((item) => item?.title);

        let tempInvestList = balanceData?.property_invest_list?.map((item) => {
          if (item?.invest_other_lists) {
            let tempData = tempInsuranceReturn
              ?.map((item2) => {
                if (!tempNameList?.includes(item2.title))
                  return {
                    amount: item2?.more_details?.policy_surrender_value,
                    created: item2.created,
                    reward_amount_per_year: item?.reward_amount_per_year || 1,
                    target_invest: {},
                    title: item2.title,
                    editable: false,
                  };
              })
              .filter((item) => item !== undefined);
            return {
              ...item,
              invest_other_lists: [...item.invest_other_lists, ...tempData],
            };
          }
          return item;
        });

        tempBalanceData = tempInvestList;
      } else {
        // ถ้ายังไม่มีหัวข้อนี้อยู่
        let tempInvestList = tempInsuranceReturn?.map((item) => {
          return {
            amount: item?.more_details?.policy_surrender_value,
            created: item.created,
            reward_amount_per_year: item?.reward_amount_per_year || 1,
            target_invest: item?.target_invest || {},
            title: item.title,
            editable: true,
          };
        });

        tempBalanceData = tempInvestList;
      }
      setReturnInsurance(tempBalanceData);
    }
  }, [balanceData]);

  return (
    <div className=" grid grid-cols-2 gap-2.5 items-center">
      <CardReport
        title={"รายรับรวมทั้งหมด"}
        panel={
          <div className=" font-semibold text-maingreen text-xl  py-4">
            {numeral(
              balanceData?.sum_salary_peryear +
                balanceData?.sum_interest_peryear +
                balanceData?.sum_other_income
            )?.format("0,0")}{" "}
            บาท
          </div>
        }
      />
      <CardReport
        title={"หนี้สินรวมทั้งหมด"}
        panel={
          <div className=" font-semibold text-mainred text-xl py-4">
            {numeral(balanceData?.debt_propotion)?.format("0,0")} บาท
          </div>
        }
      />
      <CardReport
        title={"รายจ่ายรวมทั้งหมด"}
        panel={
          <div className="flex flex-col  items-center">
            <div className=" font-semibold text-mainyellow text-xl h-fit ">
              {numeral(expenseSummary.expenseIncludingAllocation).format(
                "0,0"
              )}{" "}
              บาท
            </div>
            <div className="text-xs text-start text-black ">
              {`*เมื่อกระแสเงินสดสุทธิเป็นบวก ระบบสมมติให้บันทึกเป็นรายจ่ายเพื่อการออม/ลงทุน (${numeral(
                expenseSummary.expenseBeforeAllocation
              ).format("0,0")} + ${numeral(
                expenseSummary.positiveResidualAllocation
              ).format("0,0")} = ${numeral(
                expenseSummary.expenseIncludingAllocation
              ).format("0,0")} บาท)`}
            </div>
          </div>
        }
      />
      <CardReport
        title={"สินทรัพย์รวมทั้งหมด"}
        panel={
          <div className=" font-semibold text-mainpurple text-xl  py-4">
            {numeral(
              Number(balanceData?.sum_property_asset || 0) +
                SumDebtPersonalValue(balanceData) +
                sumCapitalInvest(
                  balanceData?.property_invest_list,
                  ReturnInsurance
                ) +
                sumDebtInvest(balanceData) +
                sumPersonalAsset(balanceData?.property_private_list) +
                SumOtherDebtAmount(balanceData) +
                Number(balanceData?.sum_property_intangible || 0)
            )?.format("0,0")}{" "}
            บาท
          </div>
        }
      />
    </div>
  );
};

// แสดงอัตราส่วนจาก owner กลางและคงความละเอียดสองตำแหน่งของสภาพคล่องไว้ในรายงานภาพรวม
const OverAllSection2 = ({
  valueProperty,
  getPropertyStatus,
  valueDebttoTotalAsset,
  getDebttoTotalAssetStatus,
  valueDebttoSalary,
  getDebttoSalaryStatus,
  valueConservation,
  getConservationStatus,
  valueInvest,
  getInvestStatus,
}) => {
  return (
    <div className=" bg-gray50 w-full h-full rounded-[20px] py-2.5 px-[15px] flex flex-col gap-[6px] ">
      <div className="flex flex-col space-y-[6px]">
        {[
          {
            title: "สภาพคล่อง",
            value: valueProperty,
            status: getPropertyStatus(),
            prefixValue: "เท่า",
            formatValue: "0[.]00",
          },
          {
            title: "หนี้สินต่อสินทรัพย์",
            value: valueDebttoTotalAsset,
            status: getDebttoTotalAssetStatus(),
            prefixValue: "%",
            formatValue: "0.00",
          },
          {
            title: "การชำระหนี้ต่อรายรับ",
            value: valueDebttoSalary,
            status: getDebttoSalaryStatus(),
            prefixValue: "%",
            formatValue: "0.00",
          },
          {
            title: "การออม",
            value: valueConservation,
            status: getConservationStatus(),
            prefixValue: "%",
            formatValue: "0.00",
          },
          {
            title: "การลงทุน",
            value: valueInvest,
            status: getInvestStatus(),
            prefixValue: "%",
            formatValue: "0.00",
          },
        ]?.map((item, index) => {
          return (
            <div key={index} className="flex justify-between">
              <div className="flex space-x-2 text-sm">
                <div className=" font-semibold ">{item?.title}</div>
                <div className=" text-mainblue font-bold ">
                  {numeral(item?.value).format(item.formatValue ?? "0")}{" "}
                  {item?.prefixValue}
                </div>
              </div>

              <div
                className={cn(
                  " font-bold ",
                  {
                    "text-[#FF0000]": item?.status === "bad",
                    "text-maingreen": item?.status === "good",
                    "text-mainblue": item?.status === "chance",
                    "text-maingray": mapStatus(item?.status) === "ไม่มีข้อมูล",
                  },
                  item?.classNameValue
                )}
              >
                {mapStatus(item?.status)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
const NetWealthSection = ({ balanceData }) => {
  const [addInvest, setAddInvest] = useState(
    balanceData?.property_invest_list ? balanceData?.property_invest_list : []
  );
  const [ReturnInsurance, setReturnInsurance] = useState([]);

  useEffect(() => {
    if (balanceData) {
      let tempInsuranceReturn = balanceData?.expenses_fixed_list
        ?.filter(
          (item) => item.options_expenses_fixed === "expenses_insuarant_life"
        )
        ?.map((item) => item.expenses_insuarant_lifes)
        ?.flat();

      let tempBalanceData = {};
      //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//

      if (
        balanceData?.property_invest_list
          ?.map((item) => item.options_property_invest_title)
          .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
        tempInsuranceReturn?.length === 0
      ) {
        // ถ้ามีหัวข้อนี้อยู่แล้ว
        let tempNameList = balanceData?.property_invest_list
          .find(
            (item) =>
              item?.options_property_invest_title ===
              "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
          )
          ?.invest_other_lists?.filter((item) => item !== null)
          ?.map((item) => item?.title);

        let tempInvestList = balanceData?.property_invest_list?.map((item) => {
          if (item?.invest_other_lists) {
            let tempData = tempInsuranceReturn
              ?.map((item2) => {
                if (!tempNameList?.includes(item2.title))
                  return {
                    amount: item2?.more_details?.policy_surrender_value,
                    created: item2.created,
                    reward_amount_per_year: item?.reward_amount_per_year || 1,
                    target_invest: {},
                    title: item2.title,
                    editable: false,
                  };
              })
              .filter((item) => item !== undefined);
            return {
              ...item,
              invest_other_lists: [...item.invest_other_lists, ...tempData],
            };
          }
          return item;
        });

        tempBalanceData = tempInvestList;
      } else {
        // ถ้ายังไม่มีหัวข้อนี้อยู่
        let tempInvestList = tempInsuranceReturn?.map((item) => {
          return {
            amount: item?.more_details?.policy_surrender_value,
            created: item.created,
            reward_amount_per_year: item?.reward_amount_per_year || 1,
            target_invest: item?.target_invest || {},
            title: item.title,
            editable: true,
          };
        });

        tempBalanceData = tempInvestList;
      }
      setReturnInsurance(tempBalanceData);
    }
    //==============================================//
  }, [balanceData]);

  const property_value =
    Number(balanceData?.sum_property_asset || 0) +
    SumDebtPersonalValue(balanceData) +
    sumCapitalInvest(addInvest, ReturnInsurance) +
    sumDebtInvest(balanceData) +
    Number(balanceData?.sum_property_private || 0) +
    SumOtherDebtAmount(balanceData) +
    Number(balanceData?.sum_property_intangible || 0);

  const status =
    balanceData?.debt_propotion >
    Number(balanceData?.sum_property_asset || 0) +
      SumDebtPersonalValue(balanceData) +
      sumCapitalInvest(addInvest, ReturnInsurance) +
      sumDebtInvest(balanceData) +
      Number(balanceData?.sum_property_private || 0) +
      SumOtherDebtAmount(balanceData) +
      Number(balanceData?.sum_property_intangible || 0)
      ? "bad"
      : "good";

  const debt_value = balanceData?.debt_propotion;
  const net_wealth_value = () => {
    let result = 0;
    let sumproperty =
      Number(balanceData?.sum_property_asset || 0) +
      SumDebtPersonalValue(balanceData) +
      sumCapitalInvest(addInvest, ReturnInsurance) +
      sumDebtInvest(balanceData) +
      Number(balanceData?.sum_property_private || 0) +
      SumOtherDebtAmount(balanceData) +
      Number(balanceData?.sum_property_intangible || 0);

    if (sumproperty) {
      result = balanceData?.debt_propotion
        ? Number(sumproperty || 0) - Number(balanceData?.debt_propotion || 0)
        : 0;
    }

    return result;
  };
  const isWealthy = Number(net_wealth_value) > Number(debt_value);

  return (
    <div>
      <CardReport
        icon_head={"/images/moneybag-report.png"}
        title={"ความมั่งคั่งสุทธิ "}
        panel={
          <div className=" px-2.5 py-[14px]">
            {status === "good" && (
              <div className=" grid grid-cols-2 gap-2  w-full h-full">
                <div className=" w-full h-full bg-[#C4F3BD] rounded-[4px] ">
                  <div className=" flex flex-col justify-center items-center h-full ">
                    <img src="/images/wealth_green.svg" className="w-14" />
                    <div className=" text-mainblue font-medium text-md mt-[3px] ">
                      สินทรัพย์
                    </div>
                    <div className="text-mainblue font-semibold text-base leading-3 pt-1">
                      {numeral(property_value).format("0,0")} บาท
                    </div>
                  </div>
                </div>
                <div className=" grid grid-rows-5 gap-2 ">
                  <div
                    className={
                      " bg-[#FFCCCC] w-full h-full  rounded-[4px] py-2 " +
                      (isWealthy ? "row-span-2 " : "row-span-3 ")
                    }
                  >
                    <div className=" flex flex-col justify-center items-center h-full ">
                      {!isWealthy && (
                        <img src="/images/debt_pdf2.svg" className="w-10" />
                      )}
                      <div className=" text-mainblue font-medium text-md mt-[3px] ">
                        หนี้สิน
                      </div>
                      <div className="text-mainblue font-semibold text-base leading-3 pt-1">
                        {numeral(debt_value).format("0,0")} บาท
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      " bg-[#CEE3FF] w-full h-full rounded-[4px] py-2 " +
                      (isWealthy ? "row-span-3 " : "row-span-2 ")
                    }
                  >
                    <div className=" flex flex-col justify-center items-center h-full ">
                      {isWealthy && (
                        <img src="/images/wealth_blue.svg" className="w-10" />
                      )}
                      <div className=" text-mainblue font-medium text-md mt-[3px] ">
                        ความมั่งคั่งสุทธิ
                      </div>
                      <div className="text-mainblue font-semibold text-base leading-3 pt-1">
                        {numeral(net_wealth_value()).format("0,0")} บาท
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {status === "bad" && (
              <div className="">
                <div className=" grid grid-cols-2 gap-2 w-full h-full">
                  <div className="grid grid-rows-5 gap-2">
                    <div className=" row-span-2"></div>
                    <div className=" w-full h-full bg-[#C4F3BD] rounded-[4px] row-span-3 p-1.5 ">
                      <div className=" flex flex-col justify-center items-center h-full ">
                        <img src="/images/wealth_green.svg" className="w-14" />
                        <div className=" text-mainblue font-medium text-md mt-[3px] ">
                          สินทรัพย์
                        </div>
                        <div className="text-mainblue font-semibold text-base leading-3 pt-1">
                          {numeral(property_value).format("0,0")} บาท
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" w-full bg-[#FFCCCC] rounded-[4px] h-full p-1.5">
                    <div className=" flex flex-col justify-center items-center ">
                      <img src="/images/wealth_bad.svg" className="w-14 h" />
                      <div className=" text-mainblue font-medium text-md mt-[3px] ">
                        หนี้สิน
                      </div>
                      <div className="text-mainblue font-semibold text-base pt-1">
                        {numeral(debt_value).format("0,0")} บาท
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" border border-mainyellow rounded-[10px]  mx-9 mt-2.5 p-1 px-7 flex gap-[6px] items-center">
                  <ICON_WARNING className={` w-7 h-7 text-mainyellow`} />
                  <div className=" text-sm text-center text-mainblue">
                    <div>หากมีหนี้สินมากกว่าสินทรัพย์</div>
                    <div>ต้องระมัดระวังในการใช้จ่ายเงิน</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        }
      />
    </div>
  );
};

export const RetireBeforeSection = ({
  dataPlanBf,
  dataAge,
  getDetailBF,
  destination = "retire",
}) => {
  return (
    <div>
      <CardReport
        icon_head={"/images/grandparents-report.png"}
        // title={"ก่อนวางแผน (ไม่สามารถเกษียณได้)"}
        title={"ก่อนวางแผน "}
        panel={
          <div>
            <div className=" px-4  mx-auto">
              <LineChartMain
                axisSize={6}
                labels={dataAge()}
                dataPlan={dataPlanBf}
                fontSize="text-sm"
                head={`สินทรัพย์เพื่อการลงทุนสุทธิ`}
              />
            </div>

            <div className="flex flex-col space-y-1 mt-1">
              {destination === "retire" &&
                getDetailBF()?.map((item, index) => {
                  return (
                    <div key={index} className="flex gap-2.5">
                      <div>{item?.icon}</div>
                      {item?.render && item?.render()}
                    </div>
                  );
                })}

              {destination === "overview" && getDetailBF()}
            </div>
          </div>
        }
      />
    </div>
  );
};

export const RetireAfterSection = ({
  dataPlanAF,
  dataAgeAF,
  getDetailAF,
  destination = "retire",
}) => {
  return (
    <div>
      <CardReport
        icon_head={"/images/grandparents-report.png"}
        // title={"หลังปรับกลยุทธ์ (สามารถเกษียณได้) "}
        title={"หลังปรับกลยุทธ์ "}
        panel={
          <div>
            <div className=" px-4 mx-auto">
              <LineChartMain
                axisSize={6}
                labels={dataAgeAF()}
                dataPlan={dataPlanAF}
                fontSize="text-sm"
                head={`สินทรัพย์เพื่อการลงทุนสุทธิ`}
              />
            </div>
            <div className="flex flex-col space-y-1 mt-1">
              {destination === "retire" &&
                getDetailAF()?.map((item, index) => {
                  return (
                    <div key={index} className="flex gap-2.5">
                      <div>{item?.icon}</div>
                      {item?.render && item?.render()}
                    </div>
                  );
                })}

              {destination === "overview" && getDetailAF()}
            </div>
          </div>
        }
      />
    </div>
  );
};

const TaxSection = ({
  taxData,
  getCaltax,
  displaySumAfterTaxPaid,
  displayTaxPaid,
  displaySumTax,
  checkPercent,
}) => {
  return (
    <div>
      <CardReport
        icon_head={"/images/tax-report.png"}
        title={"ภาษีที่ต้องจ่าย"}
        panel={
          <div>
            <div className=" px-2.5">
              <HalfChartMain
                chartWidth={"w-[180px] mt-10"}
                fontSize="text-xl"
                text={false}
                value={`0`}
                beforevalue={getCaltax()}
                aftervalue={taxData?.after_tax_paid}
                maxvalue={displayTaxPaid}
                mtText="-mt-20"
              />
              <div className=" flex justify-center gap-2.5 w-full -mt-10 ">
                <div
                  className={`bg-gray50 rounded-md py-[7px] px-2 w-20 text-mainblue text-sm font-semibold  h-6 flex gap-[5px] justify-center items-center`}
                >
                  <ICON_GRAPH className="w-6 h-6 text-maincyan " />
                  <span className=" flex-none"> {checkPercent()} %</span>
                </div>
                <div
                  className={`bg-gray50 rounded-md py-[7px] px-2 w-20 text-mainblue text-sm font-semibold  h-6 flex gap-[5px] justify-center items-center`}
                >
                  <ICON_BAHT className="w-6 h-6 text-maincyan " />
                  {numeral(displaySumTax).format("0,0")}
                </div>
              </div>
              <div className="flex flex-col space-y-0.5 mt-1 text-sm">
                {[
                  {
                    title: "ก่อนวางแผน",
                    value:
                      String(getCaltax()) === "Infinity" ? "0" : getCaltax(),
                    classNameValue: "text-mainred",
                  },
                  {
                    title: "หลังวางแผน",
                    value:
                      String(displaySumAfterTaxPaid()) === "Infinity"
                        ? "0"
                        : displaySumAfterTaxPaid(),
                    classNameValue: "text-maingreen",
                  },
                  {
                    title: "ภาษีหัก ณ ที่จ่าย",
                    value: taxData?.tax_withholding,
                    classNameValue: "text-mainblue",
                  },
                ]?.map((item, index) => {
                  return (
                    <div key={index} className="flex justify-between">
                      <div className=" font-medium text-black">
                        {item?.title}
                      </div>
                      <div className={cn("  font-medium")}>
                        <span
                          className={cn(
                            " mr-2.5 font-bold",
                            item?.classNameValue
                          )}
                        >
                          {" "}
                          {numeral(item?.value).format("0,0")}
                        </span>{" "}
                        บาท
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className=" flex justify-center items-center gap-[5px] font-bold mt-1 text-sm">
                <div className=" text-maincyan">ภาษีที่ต้องจ่าย</div>
                <div className=" text-mainorange">
                  {numeral(taxData?.final_tax)?.format("0,0")} บาท
                </div>
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

const InvestSection = () => {
  return (
    <div>
      <CardReport
        icon_head={"/images/revenue-report.png"}
        title={"สัดส่วนการลงทุน"}
        panel={
          <div>
            <ViewMyPortResult
              // isReport={true}
              status={"status"}
              isOverview={true}
            />
          </div>
        }
      />
    </div>
  );
};

// สร้างรายงานภาพรวมโดยคำนวณอัตราส่วนทางการเงินจาก owner ของแต่ละสูตรก่อนส่งให้ส่วนแสดงผล
const ReacteportOverViewPage = () => {
  const navigate = useNavigate();
  const userData = useUserStore((state) => state.userData);
  const strategy = useStrategyStore((state) => state.strategy);
  const educationData = useEducationStore((state) => state.educationData);

  const balanceData = useBalanceStore((state) => state.balanceData);
  const retireData = useRetireStore((state) => state.retireData);
  const taxData = useTaxStore((state) => state.taxData);

  const [addInvest, setAddInvest] = useState(
    balanceData?.property_invest_list ? balanceData?.property_invest_list : []
  );
  const [ReturnInsurance, setReturnInsurance] = useState([]);

  const straigyLists = strategy?.map((item) => item?.key);

  // สภาพคล่อง
  const {
    ratio: basicLiquidityRatio,
    status: basicLiquidityStatus,
  } = calculateBasicLiquidityRatio({ balanceData });
  const valueProperty = basicLiquidityRatio;

  useEffect(() => {
    if (balanceData) {
      let tempInsuranceReturn = balanceData?.expenses_fixed_list
        ?.filter(
          (item) => item.options_expenses_fixed === "expenses_insuarant_life"
        )
        ?.map((item) => item.expenses_insuarant_lifes)
        ?.flat();

      let tempBalanceData = {};
      //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//

      if (
        balanceData?.property_invest_list
          ?.map((item) => item.options_property_invest_title)
          .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
        tempInsuranceReturn?.length === 0
      ) {
        // ถ้ามีหัวข้อนี้อยู่แล้ว
        let tempNameList = balanceData?.property_invest_list
          .find(
            (item) =>
              item?.options_property_invest_title ===
              "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
          )
          ?.invest_other_lists?.filter((item) => item !== null)
          ?.map((item) => item?.title);

        let tempInvestList = balanceData?.property_invest_list?.map((item) => {
          if (item?.invest_other_lists) {
            let tempData = tempInsuranceReturn
              ?.map((item2) => {
                if (!tempNameList?.includes(item2.title))
                  return {
                    amount: item2?.more_details?.policy_surrender_value,
                    created: item2.created,
                    reward_amount_per_year: item?.reward_amount_per_year || 1,
                    target_invest: {},
                    title: item2.title,
                    editable: false,
                  };
              })
              .filter((item) => item !== undefined);
            return {
              ...item,
              invest_other_lists: [...item.invest_other_lists, ...tempData],
            };
          }
          return item;
        });

        tempBalanceData = tempInvestList;
      } else {
        // ถ้ายังไม่มีหัวข้อนี้อยู่
        let tempInvestList = tempInsuranceReturn?.map((item) => {
          return {
            amount: item?.more_details?.policy_surrender_value,
            created: item.created,
            reward_amount_per_year: item?.reward_amount_per_year || 1,
            target_invest: item?.target_invest || {},
            title: item.title,
            editable: true,
          };
        });

        tempBalanceData = tempInvestList;
      }
      setReturnInsurance(tempBalanceData);
    }
  }, [balanceData]);
  const getPropertyStatus = () => basicLiquidityStatus;

  // หนี้สินต่อสินทรัพย์
  const { ratio: valueDebttoTotalAsset } = useMemo(
    () =>
      calculateDebtToTotalAssets({
        balanceData,
        addInvest,
        returnInsurance: ReturnInsurance,
      }),
    [balanceData, addInvest, ReturnInsurance]
  );
  const getDebttoTotalAssetStatus = () => {
    if (!balanceData?.debt_propotion) return;

    if (valueDebttoTotalAsset > 50) {
      return "bad";
    }
    return "good";
  };

  // ชำระหนี้ต่อรายรับ
  const valueDebttoSalary = useMemo(() => {
    let sum = 0;
    const debtPermonth =
      balanceData?.sum_debt_short_permonth +
      balanceData?.sum_debt_long_permonth;
    const salaryPermonth = balanceData?.salary_propotion
      ? balanceData?.salary_propotion / 12
      : 0;
    sum = salaryPermonth > 0 ? (debtPermonth / salaryPermonth) * 100 : 0;
    return sum;
  }, [balanceData]);
  const getDebttoSalaryStatus = () => {
    if (
      !balanceData?.sum_debt_short_permonth &&
      !balanceData?.sum_debt_long_permonth
    )
      return;

    if (valueDebttoSalary > 50) {
      return "bad";
    }
    return "good";
  };

  // การออม
  const valueConservation = useMemo(() => {
    let sum = 0;
    if (balanceData?.sum_expenses_invest_saving) {
      sum = balanceData?.sum_expenses_invest_saving;
    }
    const finalResult =
      sum > 0 ? (sum / balanceData?.salary_propotion) * 100 : 0;
    return finalResult;
  }, [balanceData]);
  const getConservationStatus = () => {
    if (!balanceData?.sum_expenses_invest_saving) return;

    if (valueConservation < 10) {
      return "bad";
    }
    return "good";
  };

  // การลงทุน
  const valueInvest = useMemo(() => {
    let sum = 0;
    if (
      SumDebtPersonalValue(balanceData) +
        sumCapitalInvest(addInvest, ReturnInsurance) +
        sumDebtInvest(balanceData) >
      0
    ) {
      sum =
        balanceData?.net_wealth > 0
          ? ((SumDebtPersonalValue(balanceData) +
              sumCapitalInvest(addInvest, ReturnInsurance) +
              sumDebtInvest(balanceData)) /
              balanceData?.net_wealth) *
            100
          : 0;
    }
    return sum;
  }, [balanceData]);
  const getInvestStatus = () => {
    if (
      SumDebtPersonalValue(balanceData) +
        sumCapitalInvest(addInvest, ReturnInsurance) +
        sumDebtInvest(balanceData) <=
      0
    )
      return;

    if (valueInvest > 50) {
      return "good";
    }
    return "bad";
  };

  // ภาษี
  const getCaltax = () => {
    let result = 0;
    result =
      taxData?.tax_income -
      taxData?.deduction_expenses -
      taxData?.deduct_summary;

    if (userData?.is_premium) {
      result =
        TabThreeSumIncomeCalculation(taxData) -
        TabThreeExpenseCalculation(taxData) -
        taxData?.deduct_summary +
        sum408property(taxData) +
        sum408RecieveMoney(taxData);
    }

    return calculateTax(result);
  };

  const displaySumBudget = () => {
    return calculateCurrentTaxPlanDeductionTotal(taxData);
  };

  const displaySumAfterTaxPaid = () => {
    let result = 0;
    result =
      Number(taxData?.tax_income || 0) -
      Number(taxData?.deduction_expenses || 0) -
      Number(taxData?.deduct_summary || 0) -
      Number(displaySumBudget() || 0);
    if (userData?.is_premium) {
      result =
        TabThreeSumIncomeCalculation(taxData) -
        TabThreeExpenseCalculation(taxData) -
        Number(taxData?.deduct_summary || 0) -
        Number(displaySumBudget() || 0);
    }
    return calculateTax(result);
  };

  const displayTaxPaid = useMemo(() => {
    let result = calculateTax(taxData?.tax_income || 0);
    if (userData?.is_premium) {
      result =
        TabThreeSumIncomeCalculation(taxData) +
        sum408property(taxData) +
        sum408RecieveMoney(taxData);
    }
    return result;
  }, [taxData?.tax_income]);

  const getInvestSumAF = useMemo(() => {
    return userData?.is_premium
      ? InvestmentReturnCalAfter(
          retireData,
          strategy,
          balanceData,
          educationData
        )?.map((af_investment_assets, index) => {
          return {
            result: af_investment_assets?.asset_invest,
            age: retireData?.af_plan_age[index],
          };
        })
      : InvestmentReturnCalAfterNormal(retireData, strategy)?.map(
          (af_investment_assets, index) => {
            return {
              result: af_investment_assets?.asset_invest,
              age: retireData?.af_plan_age[index],
            };
          }
        );
  }, [strategy]);

  const displaySumTax = useMemo(
    () => checkSum(getCaltax(), taxData?.after_tax_paid, 0, 0),
    [getCaltax(), taxData?.after_tax_paid, 0, 0]
  );

  const checkPercent = () => {
    let result = 0;
    result = ((getCaltax() - taxData?.after_tax_paid) / getCaltax()) * 100;
    if (isNaN(result)) {
      return 0;
    }
    return Number(result)?.toFixed(2);
  };

  // วางแผนเกษียณ
  const getInvestSum = userData?.is_premium
    ? InvestmentReturnCal(
        retireData,
        balanceData,
        strategy,
        educationData
      )?.map((bf_investment_assets, index) => {
        return {
          result: bf_investment_assets?.asset_invest,
          age: retireData?.bf_plan_age[index],
        };
      })
    : InvestmentReturnNormalCal(retireData)?.map(
        (bf_investment_assets, index) => {
          return {
            result: bf_investment_assets?.asset_invest,
            age: retireData?.bf_plan_age[index],
          };
        }
      );
  const lastResultBF = getInvestSum[getInvestSum?.length - 1];
  const retirementAge = retireData?.age_retire;
  const retirementAgeAF = straigyLists?.includes("strategy_age_retire")
    ? retireData?.strategy_age_retire
    : retireData?.age_retire;

  const retireBF = getInvestSum.find(
    (result) => result.age === retirementAge
  )?.result;
  const retireAF = getInvestSumAF.find(
    (result) => result.age === retirementAgeAF
  )?.result;
  const getremainBF = getInvestSum?.filter((thisRemain, i) => {
    if (thisRemain?.result <= 0) return { ...thisRemain };
  })?.[0];
  const remainBF = getremainBF?.age;
  const beforeDiffYear = retireData?.age_retire - retireData?.age_current;
  const convertYearToMonth = (year) => {
    return year * 12;
  };
  const sumBeforeRetireInvest = useMemo(() => {
    const convertedMonth = convertYearToMonth(beforeDiffYear);
    const calPercent =
      retireData?.investment_bf_retirement < 0
        ? 3
        : retireData?.investment_bf_retirement;
    const sumPMT = calPMTFVA(
      lastResultBF?.result < 0
        ? Math.abs(lastResultBF?.result)
        : lastResultBF?.result,
      calPercent / 100 / 12,
      convertedMonth
    );
    return sumPMT;
  }, [retireData]);

  const strategyChange = retireData?.strategy_sum ? true : false;

  const dataPlanAF = () => {
    if (userData?.is_premium) {
      return InvestmentReturnCalAfter(
        retireData,
        strategy,
        balanceData,
        educationData
      )?.map((af_investment_assets) => {
        return af_investment_assets?.asset_invest;
      });
    }

    return InvestmentReturnCalAfterNormal(retireData, strategy)?.map(
      (af_investment_assets) => {
        return af_investment_assets?.asset_invest;
      }
    );
  };

  const lastResultAF = getInvestSumAF[getInvestSumAF?.length - 1];
  const getremainAF = getInvestSumAF?.filter((thisRemain, i) => {
    if (thisRemain?.result <= 0) return { ...thisRemain };
  })?.[0];
  const remainAF = Number(getremainAF?.age) - 1;
  const afterDiffYear = Math.abs(
    retireData?.strategy_age_retire - retireData?.age_current
  );

  const sumAfterRetireInvest = useMemo(() => {
    const convertedMonth = convertYearToMonth(afterDiffYear);
    const calPercent =
      retireData?.strategy_investment_bf_retirement_change < 0
        ? 3
        : retireData?.strategy_investment_bf_retirement_change ||
          retireData?.investment_bf_retirement;
    const sumPMT = calPMTFVA(
      lastResultAF?.result < 0
        ? Math.abs(lastResultAF?.result)
        : lastResultAF?.result,
      calPercent / 100 / 12,
      convertedMonth
    );

    return sumPMT;
  }, [retireData]);

  const isMobile = useIsMobile();

  const getDetailBF = () => {
    if (strategyChange) {
      if (lastResultBF?.result > 0) {
        return (
          <>
            <div className=" space-y-[10px] mb-3 mt-5">
              <div className={STYLE_FLEX_STATUS}>
                <ICON_CHECK className=" w-6 text-maincyan  " />
                <div className=" w-full text-sm flex-none">
                  <div className=" flex jusitfy-start text-start font-medium w-full h-fit ">
                    เริ่มวางแผนเกษียณตอนอายุ {retireData?.age_current} ปี
                    ประมาณการณ์เมื่อเกษียณอายุตอน {retireData?.age_retire} ปี
                    จะมีสินทรัพย์ลงทุนรวม
                  </div>
                  <div className="font-medium ">
                    {" "}
                    <span className="text-mainblue">
                      {numeral(retireBF)?.format("0,0.00")}
                    </span>{" "}
                    บาท
                  </div>
                </div>
              </div>
              <div className={STYLE_FLEX_STATUS}>
                <ICON_WARNING className=" w-6 text-mainyellow" />
                <div className="  text-sm flex-none">
                  สามารถใช้จนได้ถึงอายุ{" "}
                  <span className="font-medium">
                    {retireData?.strategy_age_dead
                      ? retireData?.strategy_age_dead
                      : retireData?.age_dead}{" "}
                    ปี
                  </span>{" "}
                  แต่อย่าประมาทนะ
                </div>
              </div>
            </div>
          </>
        );
      }
      return (
        <div className=" mt-[26px] mb-6 space-y-2.5">
          <div className={STYLE_FLEX_STATUS}>
            <ICON_CHECK className=" w-6 text-maincyan flex-none" />
            <div className="  text-sm flex-none">
              เริ่มวางแผนเกษียณตอนอายุ{" "}
              <span className="font-medium">{retireData?.age_current} ปี</span>
            </div>
          </div>
          <div className={STYLE_FLEX_STATUS}>
            <ICON_WARNING className=" w-6 text-mainyellow" />
            <div className="  text-sm flex-none">
              สามารถใช้จนได้ถึงอายุ
              <span className=" font-medium"> {remainBF} ปี </span>
            </div>
          </div>
          <div className={STYLE_FLEX_STATUS}>
            <ICON_CLOSE className=" w-6 text-mainred" />
            {isMobile ? (
              <div className="  text-sm flex-none">
                <div>
                  ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ{" "}
                  <span className=" font-medium">
                    {retireData?.age_dead} ปี
                  </span>{" "}
                </div>
                ยังขาดอยู่ทั้งหมด{" "}
                <span className=" font-medium text-mainblue">
                  {numeral(Math.abs(lastResultBF?.result))?.format("0,0")}
                  {""} บาท
                </span>
              </div>
            ) : (
              <div className="  text-sm flex-none">
                ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ{" "}
                <span className=" font-medium">{retireData?.age_dead} ปี</span>{" "}
                ยังขาดอยู่ทั้งหมด{" "}
                <span className=" font-medium text-mainblue">
                  {lastResultBF?.result < 0
                    ? numeral(lastResultBF?.result * -1)?.format("0,0")
                    : numeral(lastResultBF?.result)?.format("0,0")}
                  {""} บาท
                </span>
              </div>
            )}
          </div>
          <div className={STYLE_FLEX_STATUS}>
            <ICON_STAR className=" w-6 text-maingreen flex-none " />
            <div className="  text-sm ">
              ควรวางแผนลงทุนผลตอบแทน{" "}
              <span className=" font-semibold">
                {" "}
                {retireData?.investment_bf_retirement < 0
                  ? "3"
                  : Math.abs(retireData?.investment_bf_retirement)}{" "}
                %{" "}
              </span>
              เป็นระยะเวลา{" "}
              <span className=" font-semibold">{beforeDiffYear} ปี</span>{" "}
              เดือนละ{" "}
              <span className=" font-semibold text-mainblue">
                {numeral(sumBeforeRetireInvest)?.format("0,0")} บาท
              </span>
            </div>
          </div>

          <div className=" text-center font-semibold text-lg text-maincyan ">
            และเพื่อให้แผนเกษียณเป็นจริง
            <div className=" flex justify-center w-full">
              <div>มาปรับกลยุทธ์กันเถอะ</div>
              <ImageMain src="../images/goodthumb.png" className=" h-8 w-8 " />
            </div>
          </div>
        </div>
      );
    } else {
      if (lastResultBF?.result > 0) {
        return (
          <>
            <div className={STYLE_FLEX_STATUS}>
              <ICON_CHECK className=" w-6 text-maincyan " />
              <div className="flex justify-start text-start text-sm">
                เริ่มวางแผนเกษียณตอนอายุ {retireData?.age_current} ปี
                ประมาณการณ์เมื่อเกษียณอายุตอน {retireData?.age_retire} ปี
                จะมีสินทรัพย์ลงทุนรวม
                <div className="text-mainblue">
                  {numeral(lastResultBF.result)?.format("0,0.00")}
                </div>{" "}
                บาท
              </div>
            </div>
            <div className={STYLE_FLEX_STATUS}>
              <ICON_WARNING className=" w-6 text-mainyellow" />
              <div className="flex justify-start text-start text-sm">
                สามารถใช้จนได้ถึงอายุ{" "}
                <div className="font-medium">{retireData?.age_dead} ปี </div>
                แต่อย่าประมาทนะ
              </div>
            </div>
          </>
        );
      }
      return (
        <>
          <div className={STYLE_FLEX_STATUS}>
            <ICON_WARNING className=" w-6 text-mainyellow" />
            <div className="flex justify-start text-start text-sm">
              สามารถใช้จนได้ถึงอายุ
              <span className=" font-medium"> {remainBF} ปี </span>
            </div>
          </div>
          <div className={STYLE_FLEX_STATUS}>
            <ICON_CLOSE className=" w-6 text-mainred" />
            <div className=" flex justify-start text-start text-sm">
              <div>
                ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ{" "}
                <span className=" font-medium">{retireData?.age_dead} ปี</span>{" "}
              </div>
              ยังขาดอยู่ทั้งหมด{" "}
              <span className=" font-medium text-mainblue">
                {numeral(Math.abs(lastResultBF?.result))?.format("0,0")}
                {""} บาท
              </span>
            </div>
          </div>
          <div className={STYLE_FLEX_STATUS}>
            <div className={STYLE_FLEX_STATUS}>
              <ICON_STAR className=" w-6 text-maingreen flex-none " />
              <div className="  text-sm ">
                ควรวางแผนลงทุนผลตอบแทน{" "}
                <span className=" font-semibold">
                  {" "}
                  {Math.abs(retireData?.investment_bf_retirement)} %{" "}
                </span>
                เป็นระยะเวลา{" "}
                <span className=" font-semibold">{beforeDiffYear} ปี</span>{" "}
                เดือนละ{" "}
                <span className=" font-semibold text-mainblue">
                  {numeral(sumBeforeRetireInvest)?.format("0,0")} บาท
                </span>
              </div>
            </div>
          </div>
          <div className=" text-center font-semibold text-lg text-maincyan ">
            และเพื่อให้แผนเกษียณเป็นจริง
            <div className=" flex justify-center w-full">
              <div>มาปรับกลยุทธ์กันเถอะ</div>
              <ImageMain src="../images/goodthumb.png" className=" h-8 w-8 " />
            </div>
          </div>
        </>
      );
    }
  };

  const getDetailAF = () => {
    if (strategyChange) {
      if (lastResultAF?.result > 0) {
        return (
          <div className=" space-y-[10px] mb-3 mt-5">
            <div className={STYLE_FLEX_STATUS}>
              <ICON_CHECK className=" w-6 text-maincyan  " />
              <div className=" w-full text-sm">
                <div className=" flex flex-wrap font-medium w-full h-fit ">
                  เริ่มวางแผนเกษียณตอนอายุ {retireData?.age_current} ปี
                  ประมาณการณ์เมื่อเกษียณอายุตอน{" "}
                  {straigyLists?.includes("strategy_age_retire")
                    ? retireData?.strategy_age_retire
                    : retireData?.age_retire}{" "}
                  ปี จะมีสินทรัพย์ลงทุนรวม
                </div>
                <div className="font-medium ">
                  {" "}
                  <span className="text-mainblue">
                    {numeral(retireAF)?.format("0,0.00")}
                  </span>{" "}
                  บาท
                </div>
              </div>
            </div>
            <div className={STYLE_FLEX_STATUS}>
              <ICON_WARNING className=" w-6 text-mainyellow" />
              <div className=" flex justify-start text-start text-sm">
                สามารถใช้จนได้ถึงอายุ{" "}
                <span className="font-medium">
                  {retireData?.strategy_age_dead
                    ? retireData?.strategy_age_dead
                    : retireData?.age_dead}{" "}
                  ปี
                </span>{" "}
                แต่อย่าประมาทนะ
              </div>
            </div>
          </div>
        );
      }
      return (
        <div className=" mt-[26px] mb-6 space-y-2.5">
          <div className={STYLE_FLEX_STATUS}>
            <ICON_CHECK className=" w-6 text-maincyan " />
            <div className="  text-sm ">
              คาดการณ์สินทรัพย์เพื่อการลงทุน ณ อายุ{" "}
              <span className="font-medium">{retireData?.age_current} ปี</span>
            </div>
          </div>
          <div className={STYLE_FLEX_STATUS}>
            <ICON_WARNING className=" w-6 text-mainyellow" />
            <div className=" flex justify-start text-start text-sm ">
              สามารถใช้จนได้ถึงอายุ
              <span className=" font-medium"> {remainAF} ปี </span>
            </div>
          </div>
          <div className={STYLE_FLEX_STATUS}>
            <ICON_CLOSE className=" w-6 text-mainred" />
            {isMobile ? (
              <div className="flex justify-start text-start text-sm">
                <div>
                  ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ{" "}
                  <span className=" font-medium">
                    {retireData?.strategy_age_dead} ปี
                  </span>{" "}
                </div>
                ยังขาดอยู่ทั้งหมด{" "}
                <span className=" font-medium text-mainblue">
                  {numeral(Math.abs(lastResultAF?.result))?.format("0,0")}
                  {""} บาท
                </span>
              </div>
            ) : (
              <div className=" flex justify-start text-start text-sm">
                ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ{" "}
                <span className=" font-medium">{retireData?.age_dead} ปี</span>{" "}
                ยังขาดอยู่ทั้งหมด{" "}
                <span className=" font-medium text-mainblue">
                  {numeral(Math.abs(lastResultAF?.result))?.format("0,0")}
                  {""} บาท
                </span>
              </div>
            )}
          </div>
          <div className={STYLE_FLEX_STATUS}>
            <ICON_STAR className=" w-6 text-maingreen  " />
            <div className="  text-sm ">
              ควรวางแผนลงทุนผลตอบแทน{" "}
              <span className=" font-semibold">
                {" "}
                {retireData?.investment_bf_retirement < 0
                  ? "3"
                  : Math.abs(retireData?.investment_bf_retirement)}{" "}
                %{" "}
              </span>
              เป็นระยะเวลา{" "}
              <span className=" font-semibold">
                {Math.abs(afterDiffYear)} ปี
              </span>{" "}
              เดือนละ{" "}
              <span className=" font-semibold text-mainblue">
                {numeral(Math.abs(sumAfterRetireInvest))?.format("0,0")} บาท
              </span>
            </div>
          </div>

          <div className=" text-center font-semibold text-lg text-maincyan ">
            เพื่อให้แผนเกษียณเป็นจริง
            <div className=" flex justify-center w-full">
              <div>มาปรับกลยุทธ์อีกครั้งกันเถอะ</div>
              <ImageMain src="../images/goodthumb.png" className=" h-8 w-8 " />
            </div>
          </div>
        </div>
      );
    } else {
      if (lastResultAF?.result > 0) {
        return (
          <>
            <div className={STYLE_FLEX_STATUS}>
              <ICON_CHECK className=" w-6 text-maincyan " />
              <div className=" flex justify-start text-start text-sm">
                คาดการณ์สินทรัพย์เพื่อการลงทุน
                <div>
                  ณ วันเกษียณอายุ{" "}
                  <span className="font-medium">
                    {retireData?.age_retire} ปี
                  </span>{" "}
                  จำนวน{" "}
                  <span className=" font-medium text-mainblue">
                    {numeral(lastResultAF?.result)?.format("0,0.00")}
                    {/* {lastResult} บาท */}
                  </span>
                </div>
              </div>
            </div>
            <div className={STYLE_FLEX_STATUS}>
              <ICON_WARNING className=" w-6 text-mainyellow" />
              <div className=" flex justify-start text-start text-sm">
                สามารถใช้จนได้ถึงอายุ{" "}
                <span className="font-medium">{retireData?.age_dead} ปี </span>
                แต่อย่าประมาทนะ
              </div>
            </div>
          </>
        );
      }
      return (
        <>
          <div className={STYLE_FLEX_STATUS}>
            <ICON_WARNING className=" w-6 text-mainyellow" />
            <div className=" flex justify-start text-start text-sm">
              สามารถใช้จนได้ถึงอายุ
              <span className=" font-medium"> {remainAF} ปี </span>
            </div>
          </div>
          <div className={STYLE_FLEX_STATUS}>
            <ICON_CLOSE className=" w-6 text-mainred" />
            <div className=" flex justify-start text-start text-sm">
              <div>
                ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ{" "}
                <span className=" font-medium">{retireData?.age_dead} ปี</span>{" "}
              </div>
              ยังขาดอยู่ทั้งหมด{" "}
              <span className=" font-medium text-mainblue">
                {lastResultAF?.result < 0
                  ? numeral(lastResultAF?.result * -1)?.format("0,0")
                  : numeral(lastResultAF?.result)?.format("0,0")}{" "}
                บาท
              </span>
            </div>
          </div>
          <div className={STYLE_FLEX_STATUS}>
            <div className="flex justify-start text-start text-sm">
              ควรวางแผนลงทุนผลตอบแทน{" "}
              {Math.abs(Number(retireData?.investment_af_retirement || 0))} %
              เป็นระยะเวลา {Math.abs(afterDiffYear)} ปี เดือนละ{" "}
              {numeral(Math.abs(sumAfterRetireInvest)).format("0,0")} บาท
              และเพื่อให้แผนเกษียณเป็นจริงมาปรับกลยุทธ์กันเถอะ
            </div>
          </div>
        </>
      );
    }
  };

  const dataPlanBf = () => {
    if (userData?.is_premium) {
      return InvestmentReturnCal(
        retireData,
        balanceData,
        strategy,
        educationData
      )?.map((bf_investment_assets) => {
        return bf_investment_assets?.asset_invest;
      });
    }
    return InvestmentReturnNormalCal(retireData)?.map(
      (bf_investment_assets) => {
        return bf_investment_assets?.asset_invest;
      }
    );
  };

  // console.log("AAA ", balanceData);
  useEffect(() => {
    let ignore = false;
    first_reload(ignore);
    return () => {
      ignore = true;
    };
  }, []);

  return (
    <Container>
      <div
        // id="first_reload"
        className="pt-[14px]"
      >
        <HeaderTitle
          title="รายงาน"
          isGoback
          onClickGoBack={() => {
            navigate("/report");
          }}
        />
        <div className={STYLE_REPORT_CONTAIN}>
          <HeaderReport
            icon={"/images/coin-report.png"}
            title={"ภาพรวมเป้าหมายทางการเงินของคุณ"}
          />
          <div className=" flex flex-col gap-5 mt-[17px] ">
            <OverAllSection balanceData={balanceData} />
            <OverAllSection2
              valueProperty={valueProperty}
              getPropertyStatus={getPropertyStatus}
              valueDebttoTotalAsset={valueDebttoTotalAsset}
              getDebttoTotalAssetStatus={getDebttoTotalAssetStatus}
              valueDebttoSalary={valueDebttoSalary}
              getDebttoSalaryStatus={getDebttoSalaryStatus}
              valueConservation={valueConservation}
              getConservationStatus={getConservationStatus}
              valueInvest={valueInvest}
              getInvestStatus={getInvestStatus}
            />
            <NetWealthSection balanceData={balanceData} />

            <RetireBeforeSection
              dataPlanBf={[...dataPlanBf()]}
              dataAge={dataAge}
              getDetailBF={getDetailBF}
              destination={"overview"}
            />
            <RetireAfterSection
              dataPlanAF={[...dataPlanAF()]}
              dataAgeAF={dataAgeAF}
              getDetailAF={getDetailAF}
              destination={"overview"}
            />
            <TaxSection
              taxData={taxData}
              getCaltax={getCaltax}
              displaySumAfterTaxPaid={displaySumAfterTaxPaid}
              displayTaxPaid={displayTaxPaid}
              displaySumTax={displaySumTax}
              checkPercent={checkPercent}
            />
            <InvestSection />
          </div>
          <div className=" flex justify-center">
            <MTButton
              onClick={() => {
                navigate("/report");
              }}
              text="ย้อนกลับ"
              color="bg-white"
              border="border border-maincyan"
              colortext="text-maincyan group-hover:text-white"
              hovercolor="hover:bg-maincyan group "
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ReacteportOverViewPage;
